import { render } from "./PanelList.vue?vue&type=template&id=6d4d0059&scoped=true"
import script from "./PanelList.vue?vue&type=script&lang=js"
export * from "./PanelList.vue?vue&type=script&lang=js"

import "./PanelList.vue?vue&type=style&index=0&id=6d4d0059&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4d0059"],['__file',"src/assets/js/pages/Address/PanelList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d4d0059"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d4d0059', __exports__)) {
    api.reload('6d4d0059', __exports__)
  }
  
  module.hot.accept("./PanelList.vue?vue&type=template&id=6d4d0059&scoped=true", () => {
    api.rerender('6d4d0059', render)
  })

}


export default __exports__